<div appDragScroll class="overflow-y-auto" [style.height.px]="500">
  @if (orders(); as order) {
    <table mat-table [dataSource]="order" multiTemplateDataRows>

      <ng-container matColumnDef="date" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef> Dato</th>
        <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ element.orderDate | date }}</td>
      </ng-container>

      <ng-container matColumnDef="orderNumber" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef> Ordre#</th>
        <td mat-cell *matCellDef="let element" class="text-nowrap"> #{{ element.vismaOrderNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="storeName" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef> Butik</th>
        <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ getHumanStoreName(element.storeName) }}</td>
      </ng-container>

      <ng-container matColumnDef="status" [stickyEnd]="true">
        <th mat-header-cell *matHeaderCellDef> Status</th>
        <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ getHumanStatus(element.orderStatus) }}</td>
      </ng-container>

      <ng-container matColumnDef="totalPrice" [stickyEnd]="true">
        <th mat-header-cell *matHeaderCellDef> Købstotal</th>
        <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ element.orderTotal | price | currency }} kr.</td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns().length"
            [class.expanded-detail]="element == expandedElement()">
          <div class="detail-element"
               [@detailExpand]="element == expandedElement() ? 'expanded' : 'collapsed'">
            <h4 class="detail-element-title">Varelinjer</h4>
            <app-order-line-item-table
              [lineItems]="element.orderLines"
              [showPagination]="false"
              [hideStoreName]="true"
              [displayedColumns]="['productName', 'qty', 'unitPrice', 'totalPrice']"/>
            <div class="order-price-box">
              @if (element.deliveryPrice) {
                <p>Fragt: {{ element.deliveryPrice | price | currency }} kr.</p>
              }
              @for (discount of element.discounts; track discount?.id) {
                <p>{{ discount.name }}: {{ discount.amount | price | currency }} kr.</p>
              }
              <p class="total-price">Købstotal {{ element.orderTotal | price | currency }} kr.</p>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns();"
          class="element-row"
          [class.expanded-row]="expandedElement() === row"
          (click)="expandedElement.set(expandedElement() === row ? null : row)"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
    <mat-paginator [length]="totalItems()" [pageSize]="20" (page)="changePage($event)" [pageIndex]="pageIndex()"
                   [hidePageSize]="true"></mat-paginator>
  }
</div>
